<div id="acom">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class=" inner-card">
                    <h4 class="card-title ">Infrastructure Type</h4>
                    <div class="card-body ">
                        <table class="table table-bordered table-hover">
                            <thead>
                              <tr>
                                <th scope="col">S.No.</th>
                                <th scope="col">Infrastructure Name</th>
                                <th scope="col">No. of Infrastructure</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let item of infra;let i = index">
                                <th scope="row">{{i+1}}</th>
                                <td>{{item.name}}</td>
                                <td>{{item.count}}</td>
                                
                              </tr>
                              
                            </tbody>
                          </table>
                            <div id="infraCarousel" class="carousel slide" data-bs-ride="carousel">
                              <div class="carousel-indicators">
                                <button type="button" data-bs-target="#infraCarousel" *ngFor="let img of imgUrl, let i = index" class="{{ (i == 0) ? 'active' : '' }}" data-bs-slide-to="0" aria-current="true" aria-label="Slide 1"
                                attr.data-bs-slide-to="{{i}}"></button>
                              </div>
                                <div class="carousel-inner text-center py-5 px-3">
                                  <div class="carousel-item" *ngFor="let img of imgUrl, let i=index" [ngClass]="(i == 0 ) ? 'active' : ''">
                                    <a appLazyload href="{{img}}" data-lightbox="Infrastructure"><img appLazyload [src]="img" alt="Infrastructure" class="img-fluid rounded"></a>
                                  </div>
                                </div>
                                <button class="carousel-control-prev" type="button" data-bs-target="#infraCarousel" data-bs-slide="prev">
                                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                  <span class="visually-hidden">Previous</span>
                                </button>
                                <button class="carousel-control-next" type="button" data-bs-target="#infraCarousel" data-bs-slide="next">
                                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                  <span class="visually-hidden">Next</span>
                                </button>
                              </div>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>